import {NineSlicePlane, Sprite} from '@pixi/react';
import {Assets} from 'pixi.js';
import {Scene} from './Scene';
import {AVATAR_OPTIONS_PANEL, LOBBY_BACKGROUND} from '../assetManifest';
import {useAvatarEdit} from '../state/useAvatarEdit';

export function Lobby() {
    const [avatarEdit] = useAvatarEdit();
    return (
        <Scene>
            <Sprite texture={Assets.get(LOBBY_BACKGROUND)}/>
            {avatarEdit
                ? <NineSlicePlane
                    texture={Assets.get(AVATAR_OPTIONS_PANEL)}
                    leftWidth={50}
                    topHeight={50}
                    rightWidth={50}
                    bottomHeight={50}
                    width={500}
                    height={585}
                    x={455}
                    y={280}/>
                : <></>}
            
        </Scene>
    );
}
